import React from 'react';
import _ from 'lodash';
import {createUUID} from 'common/utils';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {
  DEFAULT_CONFIG,
  REQUEST_DETAILS_CHANGES_TYPES,
} from 'common/requestDetails/constants.js';
import {Grid, Button} from 'semantic-ui-react';

export const SelectVendorModal = ({
  active,
  cancelAction,
  selectAction,
  vendors,
  selectedVendor,
}) => {
  return (
    <FemaGoModal
      size="fullscreen"
      title="IFMIS Vendor Record"
      open={active}
      cancelAction={cancelAction}
      confirmButton="hidden"
    >
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <FemaGoTable basic={true} columns={10} type="entry" celled={false}>
              <FemaGoTable.Header>
                <FemaGoTable.Row>
                  <FemaGoTable.HeaderCell>Vendor ID</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>DUNS</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>Legal name</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>EIN</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>Bank account</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>Bank routing</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>Zip code</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>Status</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>Category</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>Option</FemaGoTable.HeaderCell>
                </FemaGoTable.Row>
              </FemaGoTable.Header>
              <FemaGoTable.Body>
                {_.map(vendors, (vendor, ind) => {
                  return (
                    <FemaGoTable.Row key={ind}>
                      <FemaGoTable.TextCell>
                        {_.get(vendor, 'vendorId')}
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>{_.get(vendor, 'duns')}</FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        {_.get(vendor, 'legalName')}
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>{_.get(vendor, 'ein')}</FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        {_.get(vendor, 'bankInfoList.0.accountNumber')}
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        {_.get(vendor, 'bankInfoList.0.routingNumber')}
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        {_.get(vendor, 'zipcode')}
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        {_.get(vendor, 'vendorIfmisFlag')}
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        {_.get(vendor, 'vendorCategoryCode')}
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        <a
                          href="#"
                          title={`Select vendor with id ${_.get(vendor, 'vendorId')}`}
                          onClick={() => selectAction(vendor.vendorId)}
                        >
                          {vendor.vendorId === selectedVendor
                            ? 'Current vendor'
                            : 'Select this vendor'}
                        </a>
                      </FemaGoTable.TextCell>
                    </FemaGoTable.Row>
                  );
                })}
              </FemaGoTable.Body>
            </FemaGoTable>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </FemaGoModal>
  );
};
